import { Skeleton } from '@mui/material';

export default function SkeletonLoader() {
    return (
        <Skeleton
            variant="rectangular"
            width="100%"
            height={5}
            animation="wave"
            sx={{
                borderRadius: 20, // Half of height for pill shape
                mb: 2, // Add spacing below
                bgcolor: 'grey.200',
                transform: 'none', // Disable default scale transform
                transition: 'opacity 0.3s ease-in-out',
                '& .MuiSkeleton-wave': {
                    bgcolor: 'grey.300',
                },
                '&:hover': {
                    opacity: 0.8,
                },
            }}
        />
    );
}
